import React from 'react';
import './ProgramRenderer.css';
import ImageOverlay from '../Misc/ImageOverlay';
import GalleryImage from '../Gallery/GalleryImage';
import Slider from "react-slick";

export default function ProgramRenderer(props) {
    const data = props.data;
    const [showOverlay, setShowOverlay] = React.useState(false);
    const [currImage, setCurrImage] = React.useState(0);

    return (
        <div className="program">
            <div className="main-program-data">
                <h1>{data.title}</h1>
                <p className="program_desc">{data.description}</p>
            </div>
            {data.content.map((content, key_1) => (
                <React.Fragment key={key_1}>
                    <h2>{content.primaryHeading}</h2>
                    {content.subContent
                        .filter(subContent => 
                            subContent.secondaryHeading.trim() !== "" ||
                            subContent.description.trim() !== "" ||
                            (subContent.images && subContent.images.length > 0)
                        )
                        .map((subContent, key_2) => {
                            const images = subContent.images || [];
                            const multipleImages = images.length > 1;

                            // Slider settings
                            const sliderSettings = {
                                dots: true,
                                infinite: multipleImages,
                                speed: 500,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: true,
                                autoplay: multipleImages,
                                autoplaySpeed: 3000,
                            };

                            return (
                                <React.Fragment key={key_2}>
                                    {subContent.secondaryHeading.trim() && <h3>{subContent.secondaryHeading}</h3>}
                                    {subContent.description.trim() && <p className="program_desc subcontent_desc">{subContent.description}</p>}

                                    {images.length > 0 && (
                                        <div className="content_gallery">
                                            <Slider {...sliderSettings}>
                                                {images.map((image, key_3) => (
                                                    <GalleryImage
                                                        key={key_3}
                                                        image={image}
                                                        index={key_3}
                                                        overlayVal={(key_1 + 1) * 10 + key_2 + 1}
                                                        setShowOverlay={setShowOverlay}
                                                        setCurrImage={setCurrImage}
                                                    />
                                                ))}
                                            </Slider>
                                        </div>
                                    )}

                                    {showOverlay === (key_1 + 1) * 10 + key_2 + 1 ? (
                                        <ImageOverlay 
                                            images={images} 
                                            currImage={currImage} 
                                            setShowOverlay={setShowOverlay} 
                                        />
                                    ) : null}
                                </React.Fragment>
                            );
                        })}
                </React.Fragment>
            ))}
        </div>
    );
}
